<template>
  <header>
    <div class="inner">
      <h2>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="37.143"
          viewBox="0 0 26 37.143"
        >
          <g transform="translate(-280 -214)">
            <rect
              width="10.506"
              height="10.506"
              transform="translate(287.428 214) rotate(45)"
              fill="#c4c06d"
            />
            <rect
              width="10.506"
              height="10.506"
              transform="translate(298.571 225.143) rotate(45)"
              fill="#c4c06d"
            />
            <rect
              width="10.506"
              height="10.506"
              transform="translate(287.428 236.286) rotate(45)"
              fill="#c4c06d"
            />
          </g>
        </svg>
        <span class="title"><slot name="title">お問い合わせ</slot></span>
        <span class="subtitle"><slot name="subtitle">Contact</slot></span>
      </h2>
      <div class="tx">
        <h3>
          <slot name="leadtext">
            御葬儀についてのご心配、ご不安 事前のご相談もお気軽にご連絡ください
            24時間、365日ご対応しております。
          </slot>
        </h3>
        <p>
          <slot name="text">
            お急ぎのご連絡だけでなく、事前のご相談や、葬儀についてご不明な点や不安な点などございましたら、お気軽にご連絡ください。
          </slot>
        </p>
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
header {
  padding: 0 1rem;
  padding-top: 145px;
  width: 100%;
  @include tb {
    padding-top: 80px;
  }
  .inner {
    max-width: $maxwidth;
    margin: 2.5rem auto;
    margin-top: 0;
    h2 {
      display: inline-flex;
      align-items: center;
      margin: 2.5rem 0;
      font-size: 2.25rem;
      gap: 1rem;
      @include tb {
        font-size: 1.5rem;
      }
      svg {
        height: 2.5rem;
      }
      .title {
        flex-grow: 1;
        flex-shrink: 0;
      }
      .subtitle {
        flex-grow: 0;
        color: #666;
        font-size: 1rem;
        padding-top: 0.5em;
        @include tb {
          font-size: 0.875rem;
        }
        @include sp {
          font-size: 0.65rem;
        }
      }
    }
    .tx {
      border-top: 1px solid $color-lgray;
      border-bottom: 1px solid $color-lgray;
      padding: 2.5rem 0;
      h3 {
        text-align: center;
        font-size: 2rem;
        margin: 0 auto;
        line-height: 1.5;
        max-width: 640px;
        position: relative;
        padding-bottom: 2rem;
        margin-bottom: 2rem;
        &::after {
          @include pseudo;
          width: 6rem;
          height: 1px;
          left: calc(50% - 3rem);
          bottom: 0;
        }
        @include tb {
          font-size: 1.5rem;
        }
      }
      p {
        margin: 0 auto;
        max-width: 720px;
        line-height: 2;
      }
    }
  }
}
</style>
